module.exports = "/images/header-logo.png?b98dbbba88d86e037e9c465dc8924668";